<template>
  <div>
    <div class="title mb-5">{{ $vuetify.lang.t('$vuetify.application.title') }}</div>
    <application></application>
  </div>
</template>

<script>
  import Application from "./../../components/application/Index";

  export default {
    metaInfo() {
      return {
        title: this.$vuetify.lang.t("$vuetify.application.title")
      };
    },
    components: {
      Application
    }
  }
</script>

<style scoped>

</style>